import Link from 'next/link'
import { useRouter } from 'next/router'
import { FormEvent, useRef, useState } from 'react'
import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import Form from 'react-bootstrap/Form'
import Spinner from 'react-bootstrap/Spinner'

import Container from '@/components/Container/Container'
import { ExplicitHead } from '@/components/DefaultHead/DefaultHead'
import Main from '@/components/Main/Main'
import Panel from '@/components/Panel/Panel'
import SimpleHeader from '@/components/SimpleHeader/SimpleHeader'
import profileService from '@/services/profile.service'
import { redirectOnLogin } from '@/utils/helpers'

const SignIn = () => {
  const emailRef = useRef<HTMLInputElement>(null)
  const passwordRef = useRef<HTMLInputElement>(null)
  const router = useRouter()
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault()
    setIsLoading(true)
    setError('')
    const email = emailRef.current?.value || ''
    const password = passwordRef.current?.value || ''
    profileService
      .login(email, password)
      .then(() => redirectOnLogin(router))
      .catch((err) => {
        setError(err.message)
        setIsLoading(false)
      })
  }

  return (
    <Main>
      <Container small>
        <ExplicitHead description='EDHREC Sign In' keywords='EDHREC,sign,in' title='Sign In | EDHREC' />
        <SimpleHeader>Sign In</SimpleHeader>
        <Panel>
          <form className='d-grid gap-3 pb-3' onSubmit={onSubmit}>
            <FloatingLabel label='Email'>
              <Form.Control placeholder='email' ref={emailRef} required type='email' />
            </FloatingLabel>
            <FloatingLabel label='Password'>
              <Form.Control placeholder='password' ref={passwordRef} required type='password' />
            </FloatingLabel>
            <Button disabled={isLoading} size='lg' type='submit' variant='primary'>
              {isLoading ? <Spinner animation='border' size='sm' /> : 'Sign In'}
            </Button>
            {error && <Alert variant='danger'>{error}</Alert>}
            <Link className='m-auto' href='/signup'>
              Sign Up
            </Link>
            <Link className='m-auto' href='/forgot-password'>
              Forgot your password?
            </Link>
          </form>
        </Panel>
      </Container>
    </Main>
  )
}

export default SignIn
